import classes from './OtpInput.module.css';
import OTPInput from 'otp-input-react';
import clsx from 'clsx';
const OtpInput = ({ value, setter, isVerified, className, ...rest }) => {
  return (
    <div
      className={clsx(classes.wrapper, className, {
        [classes.typing]: value,
        [classes.verifying]: value?.length === 6,
        [classes.verified]: isVerified === true,
        [classes.error]: isVerified === false
      })}
      {...rest}>
      <OTPInput
        value={value}
        onChange={setter}
        autoFocus
        OTPLength={6}
        otpType="number"
        disabled={false}
        secure
      />
      {isVerified === false && <p className="errorText">Incorrect OTP Entered</p>}
    </div>
  );
};

export default OtpInput;
